import { TrainingRecordEdit } from '@client/components/compliance/training/TrainingRecordEdit';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/console/$orgId/compliance/training/user/$userId/add')({
    component: TrainingRecordEdit,
});
